import src from "IMAGE";
export default { src, width: 339, height: 121, blurWidth: 0, blurHeight: 0};
